// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  padding: 120px 0 80px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.hero::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.hero__content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.hero__badge {
  display: inline-block;
  padding: 8px 16px;
  background: rgba(99, 102, 241, 0.1);
  color: var(--primary-color);
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
}

.hero__title {
  font-size: 64px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.gradient-text {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero__subtitle {
  font-size: 20px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero__actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 80px;
  flex-wrap: wrap;
}

.btn--large {
  padding: 16px 32px;
  font-size: 16px;
}

.btn--outline {
  background: white;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.btn--outline:hover {
  background: var(--primary-color);
  color: white;
}

.hero__stats {
  display: flex;
  justify-content: center;
  gap: 64px;
  padding-top: 64px;
  border-top: 1px solid var(--border-color);
}

.stat {
  text-align: center;
}

.stat__number {
  font-size: 40px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.stat__label {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

@media (max-width: 768px) {
  .hero {
    padding: 80px 0 60px;
  }

  .hero__title {
    font-size: 40px;
  }

  .hero__subtitle {
    font-size: 18px;
  }

  .hero__actions {
    margin-bottom: 60px;
  }

  .hero__stats {
    gap: 32px;
    padding-top: 40px;
  }

  .stat__number {
    font-size: 32px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;EACnC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".hero {\r\n  padding: 120px 0 80px;\r\n  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -50%;\r\n  right: -20%;\r\n  width: 600px;\r\n  height: 600px;\r\n  background: radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 70%);\r\n  border-radius: 50%;\r\n}\r\n\r\n.hero::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -30%;\r\n  left: -10%;\r\n  width: 500px;\r\n  height: 500px;\r\n  background: radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%);\r\n  border-radius: 50%;\r\n}\r\n\r\n.hero__content {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.hero__badge {\r\n  display: inline-block;\r\n  padding: 8px 16px;\r\n  background: rgba(99, 102, 241, 0.1);\r\n  color: var(--primary-color);\r\n  border-radius: 50px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.hero__title {\r\n  font-size: 64px;\r\n  font-weight: 800;\r\n  line-height: 1.1;\r\n  margin-bottom: 24px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.gradient-text {\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.hero__subtitle {\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 40px;\r\n  max-width: 600px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.hero__actions {\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n  margin-bottom: 80px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn--large {\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n}\r\n\r\n.btn--outline {\r\n  background: white;\r\n  color: var(--primary-color);\r\n  border: 2px solid var(--primary-color);\r\n}\r\n\r\n.btn--outline:hover {\r\n  background: var(--primary-color);\r\n  color: white;\r\n}\r\n\r\n.hero__stats {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 64px;\r\n  padding-top: 64px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.stat {\r\n  text-align: center;\r\n}\r\n\r\n.stat__number {\r\n  font-size: 40px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.stat__label {\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hero {\r\n    padding: 80px 0 60px;\r\n  }\r\n\r\n  .hero__title {\r\n    font-size: 40px;\r\n  }\r\n\r\n  .hero__subtitle {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .hero__actions {\r\n    margin-bottom: 60px;\r\n  }\r\n\r\n  .hero__stats {\r\n    gap: 32px;\r\n    padding-top: 40px;\r\n  }\r\n\r\n  .stat__number {\r\n    font-size: 32px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
